import React from 'react';
import { connect } from 'react-redux';
import FilterModal from '../modals/FilterModal';

// return filters, filtertags, and sites

class SiteFilterModal extends React.Component {
  constructor(props) {
    super(props);
  }

  getCategories = () => {
    return this.props.categories.filter((d) => d.for_sites);
  };

  render() {
    return (
      <>
        <FilterModal title="Filter Sites" {...this.props} categories={this.getCategories()} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.siteNotes.categories,
});

export default connect(mapStateToProps)(SiteFilterModal);
